import { useState } from 'react'

/** 月間の通の表示範囲: 1 日ずつ (日送り) か、 対象月の全日をまとめて (月全体)。 翌日の通は 1 日だけ。 */
export type NoticeView = 'day' | 'month'

/**
 * 詳細の 「1 日 / 月全体」 の切り替えの状態。 月全体になるのは月間の通だけ。
 * 取得の引数 (月全体は 'all') を決めるので、 取得より前に呼ぶ。
 */
export function useNoticeDetailView(isMonthly: boolean): {
  view: NoticeView
  setView: (next: NoticeView) => void
  wholeMonth: boolean
} {
  const [view, setView] = useState<NoticeView>('day')
  return { view, setView, wholeMonth: isMonthly && view === 'month' }
}
